import { useEffect } from "react";
import { Flex, Button, chakra } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { H2, BodyText } from "src/atoms/typography";
import FullScreen from "src/atoms/FullScreen";
import { SceneLayout } from "src/components/SceneLayout";
import setWizardWindowSize from "src/utils/setWizardWindowSize";
import { Trans, useTranslation } from "react-i18next";
import { Lottie } from "src/components/Lottie";
import TermsAndPrivacyPolicy from "./TermsAndPrivacyPolicy";
import BackButton from "src/components/BackButton";

const EnchantedSpan = chakra("span");

function Welcome({ openWizard, hasDevices, initialStep, frame }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setWizardWindowSize();
    return () => {
      frame && frame.setDefaults();
    };
  }, [frame]);

  const path = hasDevices ? "nearby-devices" : "manual-pairing";
  const isWizardOpen = initialStep != null;
  return (
    <>
      <FullScreen>
        <SceneLayout
          absolute={
            !isWizardOpen && (
              <>
                <BackButton
                  position="fixed"
                  top="5px"
                  left="90px"
                  onClick={() => {
                    navigate("/onboarding", {
                      state: {
                        showLastStep: true
                      }
                    });
                  }}
                />
              </>
            )
          }
          centerProps={{ width: "320px" }}
          center={
            <>
              <Link to="/login">
                <Button
                  variant="flatPrimary"
                  borderRadius="12px"
                  py="5px"
                  px="14px"
                  minWidth="56px"
                  position="absolute"
                  left="8px"
                  top="12px"
                >
                  {t("buttons.logIn")}
                </Button>
              </Link>
              <Lottie
                width="222px"
                height="204px"
                animationName="getApp.json"
              />
              <H2 textAlign="center" color="highEmphasis" mt="16px">
                {t("welcome.heading")}
              </H2>
              <BodyText textAlign="center" mt="8px" color="mediumEmphasis">
                <Trans
                  i18nKey="welcome.pair.text"
                  components={{
                    a: (
                      <EnchantedSpan
                        color="primary"
                        textDecoration="none"
                        cursor="pointer"
                        onClick={() => navigate("/how-it-works")}
                      >
                        www.barkio.com
                      </EnchantedSpan>
                    )
                  }}
                />
              </BodyText>
            </>
          }
          bottomProps={{ mb: "18px", px: "16px" }}
          bottom={
            <Flex flexDir="column" alignItems="center" rowGap="1rem">
              <Button
                variant="containedPrimary"
                onClick={() => openWizard(path)}
                minWidth="200px"
                mt="32px"
              >
                {t("buttons.iHaveDeviceReady")}
              </Button>
              <TermsAndPrivacyPolicy />
            </Flex>
          }
        />
      </FullScreen>
    </>
  );
}

export default Welcome;
